import React from "react";
import { WidgetProps } from "@rjsf/utils";
import { Input } from "antd";

const TelephoneWidget = (props: WidgetProps) => {
  const {
    id,
    value,
    disabled,
    readonly,
    onChange,
    onBlur,
    onFocus,
  } = props;

  return (
    <Input
      type="tel"
      id={id}
      name={id}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => onBlur(id, value)}
      onFocus={() => onFocus(id, value)}
      disabled={disabled || readonly} // Use disabled for visual styling when readonly
      readOnly={readonly}
      pattern="[0-9]{1,12}" //only numbers, maxlength 12
      maxLength={12} //, maxlength 12
      onKeyUp={(e) => {
        // remove characters 
        e.currentTarget.value = e.currentTarget.value.replace(/[^0-9-]/g, '');
      }}
     
    />
  );
};

export default TelephoneWidget;
